import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  NavLink
} from "react-router-dom";
import Home from "./components/Home";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { GetStarted } from "./components/GetStarted";
import Secretariat from "./components/Secretariat";
import Census from "./components/Census";
import Tarbiyyah from "./components/Tarbiyyah";
import NoMatch from "./components/NoMatch";
import Default from "./components/layouts/Default";
import Dashboard from "./components/layouts/Dashboard";
import UserHome from "./components/UserHome";
import Tabligh from "./components/Tabligh";
import Tarbiyyat from "./components/Tarbiyyat";
import Umoor_e_tulaba from "./components/Umoor_e_tulaba";
import Waqar_e_amal from "./components/Waqar_e_amal";
import Atfal from "./components/Atfal";
import Maal from "./components/Maal";
import Tahrik_jadid from "./components/Tahrik_jadid";
import Muhasba from "./components/Muhasba";
import Sehhat_e_jismani from "./components/Sehhat_e_jismani";
import Sanat_tijarat from "./components/Sanat_tijarat";
import Ishaat from "./components/Ishaat";
import Khidmate_e_khalq from "./components/Khidmate_e_khalq";
import Umoomi from "./components/Umoomi";
import Taleem from "./components/Taleem";
import MyQaideen from "./components/MyQaideen";
import SubmitedReports from "./components/SubmitedReports";
import { Provider } from "react-redux";

import store from "./store";

import { createBrowserHistory } from "history";

class App extends Component {
  componentDidMount() {}
  constructor() {
    super();
  }

  render() {
    const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
      <Route
        {...rest}
        render={props => (
          <Layout>
            <Component {...props} />
          </Layout>
        )}
      />
    );

    return (
      <Provider store={store}>
        <div>
          <Router>
            <Switch>
              <AppRoute exact path="/" layout={Default} component={Home} />
              <AppRoute
                exact
                path="/tarbiyyah"
                layout={Dashboard}
                component={Tarbiyyah}
              />
              <AppRoute
                path="/dashboard"
                layout={Dashboard}
                component={UserHome}
              />
              <AppRoute path="/tajneed" layout={Dashboard} component={Census} />
              <AppRoute
                path="/tabligh"
                layout={Dashboard}
                component={Tabligh}
              />
              <AppRoute
                path="/Secretariat"
                layout={Dashboard}
                component={Secretariat}
              />
              <AppRoute
                path="/Tarbiyyat"
                layout={Dashboard}
                component={Tarbiyyat}
              />
              <AppRoute
                path="/Umoor_e_tulaba"
                layout={Dashboard}
                component={Umoor_e_tulaba}
              />
              <AppRoute
                path="/Waqar_e_amal"
                layout={Dashboard}
                component={Waqar_e_amal}
              />
              <AppRoute path="/Atfal" layout={Dashboard} component={Atfal} />
              <AppRoute path="/Maal" layout={Dashboard} component={Maal} />
              <AppRoute
                path="/Tahrik_jadid"
                layout={Dashboard}
                component={Tahrik_jadid}
              />
              <AppRoute
                path="/Muhasba"
                layout={Dashboard}
                component={Muhasba}
              />
              <AppRoute
                path="/Sehhat_e_jismani"
                layout={Dashboard}
                component={Sehhat_e_jismani}
              />
              <AppRoute
                path="/Sanat_tijarat"
                layout={Dashboard}
                component={Sanat_tijarat}
              />
              <AppRoute path="/Ishaat" layout={Dashboard} component={Ishaat} />
              <AppRoute
                path="/Khidmate_e_khalq"
                layout={Dashboard}
                component={Khidmate_e_khalq}
              />
              <AppRoute path="/Umoomi" layout={Dashboard} component={Umoomi} />
              <AppRoute path="/taleem" layout={Dashboard} component={Taleem} />
              <AppRoute
                path="/myqaideen"
                layout={Dashboard}
                component={MyQaideen}
              />
              <AppRoute
                path="/reports"
                layout={Dashboard}
                component={SubmitedReports}
              />
              <Route component={NoMatch} />
            </Switch>
          </Router>
        </div>
      </Provider>
      //     <React.Fragment>
      //         <Router>
      //           <div>

      // <Switch>
      //      <Route exact path="/" component={Default} >
      //             <Route exact path="/" component={Home} />
      //             <Route path="/GetStarted" component={GetStarted} />
      //             <Route path="/Secretariat" component={Secretariat} />
      //             <Route path="/Census" component={Census} />
      //             <Route path="/Tarbiyyah" component={Tarbiyyah} />
      //             <Route component={NoMatch} />
      //      </Route>
      //           </Switch>

      // </div>

      //         </Router>

      //     </React.Fragment>
    );
  }
}

export default App;
